import { useState } from 'react';

import {
  getListOfStores,
  getPartnerId,
  logAnalyticMozartDialog,
  mozartDialogOpened,
} from 'features/mozart-notifications/infra';

export function useMozartNotifications() {
  const [open, setOpen] = useState(false);

  const _partnerId = getPartnerId();
  const _stores = getListOfStores();

  const mozartDialogs = mozartDialogOpened();

  const handleClickMozarBtn = () => {
    logAnalyticMozartDialog({
      partnerId: _partnerId,
      action: 'open_dialog',
      storeId: _stores.length === 1 ? _stores[0].id : NaN,
    });
    setOpen(value => {
      mozartDialogs.dispatch(!value);
      return !value;
    });
  };

  const handleClose = () => {
    mozartDialogs.dispatch(false);
    setOpen(false);
  };

  return {
    open,
    handleClickMozarBtn,
    handleClose,
  };
}
